import React from "react";
import styles from "./tax.module.css";
import { CheckBox } from "./../inputs/CheckBox";
import { useSelector } from "react-redux";
import Indanegas from "../../assets/Indane.png";
import hpgas from "../../assets/Hp.png";
import bharatgas from "../../assets/Bharatgas.png";
import moment from "moment";
import useAmountToWords from "../../utils/Hook/useAmountToWords";

const copyType = [
  {
    type: "Original",
  },
  {
    type: "Duplicate",
  },
  {
    type: "Triplicate",
  },
];

const TaxInvoice4 = React.memo(
  ({
    doc_name,
    doc_type,
    previewRef,
    listdata,
    net_total,
    time_of,
    copy_type = copyType,
  }) => {
    const { profile_data, seal_image, signature_image, upi_qr_image, upi_id } =
      useSelector((state) => state.profile);
    const { omc_name, omc_data } = useSelector((state) => state.other);
    const convertAmountToWords = useAmountToWords(
      Number(net_total || 0).toFixed(0)
    );

    return (
      <div
        ref={previewRef}
        // style={{

        // }}
      >
        {Array(2)
          .fill()
          .map((v, i) => (
            <div
              key={i}
              style={{
                marginLeft: 0,
                borderTop: i % 2 == 1 ? "1px solid black" : "",
              }}
            >
              <div
                className={styles.invoice_main}
                style={{
                  marginLeft: "60px",
                  marginBottom: 0,
                  paddingRight: "3rem",
                }}
              >
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "18px",
                    fontWeight: "bold",

                    padding: "0 0",
                    marginBottom: "1rem",
                  }}
                >
                  {doc_name?.toUpperCase()}
                </div>
                <div
                  style={{
                    width: "100%",
                    fontSize: "14px",
                    textAlign: "right",
                    padding: "0 2rem 5px 0",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "0.5rem", // Add some space between items
                  }}
                >
                  {copy_type.map((v, i) => (
                    <React.Fragment key={i}>
                      <label style={{ display: "flex", alignItems: "center" }}>
                        <CheckBox /> {v?.type}
                      </label>
                      {i !== copy_type.length - 1 && "/"}
                    </React.Fragment>
                  ))}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "1rem",
                  }}
                >
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                    }}
                  >
                    <img
                      id="Aname"
                      style={{ width: "170px" }}
                      src={
                        omc_name == "IOCL"
                          ? Indanegas
                          : omc_name == "HPCL"
                          ? hpgas
                          : omc_name == "BPCL"
                          ? bharatgas
                          : ""
                      }
                    />
                  </div>

                  <div
                    style={{
                      flex: 3,
                      gap: ".25rem",
                      marginLeft: "2rem",
                      flexDirection: "column",
                      display: "flex",
                      alignItems: "flex-start",
                      width: "100%",
                      fontSize: "14px",
                    }}
                  >
                    {/* <div style={{ fontWeight: "bold", fontSize: "15px" }}>
                      {profile_data?.name?.toUpperCase()}
                    </div>
                    <div>
                      {profile_data.ADDRESS}, {profile_data?.LOCATION},
                    </div>
                    <div>
                      {profile_data.DISTRICT}, {profile_data.state_name} ,
                      {profile_data?.PINCODE},
                    </div>

                    <div> GSTIN/UIN: {profile_data?.gst}</div> */}

                    <div style={{ fontWeight: "bold", fontSize: "15px" }}>
                      {profile_data?.name?.toUpperCase()}
                    </div>
                    <div style={{ maxWidth: "400px" }}>
                      {profile_data.ADDRESS}, {profile_data?.LOCATION},{" "}
                      {profile_data.DISTRICT}, {profile_data.state_name} ,
                      {profile_data?.PINCODE},
                    </div>
                    <div>
                      PH:{profile_data?.mobile},{profile_data?.landline} E-Mail
                      :{profile_data?.email}
                    </div>
                    {/* <div>
                PH:{profile_data?.mobile},{profile_data?.landline}
              </div> */}
                    <div></div>
                    <div> GSTIN/UIN: {profile_data?.gst}</div>
                  </div>
                </div>
                <table className={styles.table_1}>
                  <tr>
                    <td colSpan={2}>VOUCHER NO. : {listdata?.SR_NO}</td>
                    <td colSpan={2}>
                      VOUCHER DATE :{" "}
                      {moment(listdata?.SR_NO_DATE).format("DD-MMM-YYYY")}
                    </td>
                    <td colSpan={2} style={{ minWidth: "230px" }}>
                      DATE OF {time_of.toUpperCase()} :{" "}
                      {moment(listdata?.SR_NO_DATE).format("DD-MMM-YYYY")}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={6}>
                      <div
                        style={{
                          flex: 1,
                          gap: ".25rem",
                          flexDirection: "column",
                          display: "flex",
                          alignItems: "flex-start",
                        }}
                      >
                        <div style={{ fontSize: "13px" }}>Payer Details</div>

                        {listdata?.CVO_NAME && (
                          <div style={{ fontWeight: "bold", fontSize: "13px" }}>
                            {listdata?.CVO_NAME.toUpperCase()}
                          </div>
                        )}
                        {listdata?.CVO_NAME !== "CASH SALES / HOUSEHOLDS" && (
                          <>
                            {listdata?.CVO_ADDRESS && (
                              <div
                                style={{
                                  wordWrap: "break-word",
                                  whiteSpace: "normal",
                                  maxWidth: "100%",
                                }}
                              >
                                {listdata.CVO_ADDRESS
                                  ? ` ${listdata.CVO_ADDRESS} ,`
                                  : ""}
                                {listdata.CVO_LOCATION
                                  ? ` ${listdata.CVO_LOCATION} ,`
                                  : ""}
                                {listdata.CVO_DISTRICT
                                  ? ` ${listdata.CVO_DISTRICT} ,`
                                  : ""}
                                {listdata.B_STATE_NAME
                                  ? ` ${listdata.B_STATE_NAME} ,`
                                  : ""}
                                {listdata.CVO_PINCODE
                                  ? ` ${listdata.CVO_PINCODE} `
                                  : ""}
                              </div>
                            )}
                            {(listdata?.MOBILE || listdata?.EMAIL) && (
                              <div>
                                {" "}
                                {listdata?.MOBILE
                                  ? `PH:${listdata?.MOBILE || "NA"}`
                                  : ""}{" "}
                                {listdata?.EMAIL
                                  ? `Email:${listdata?.EMAIL || "NA"}`
                                  : ""}{" "}
                              </div>
                            )}
                            {listdata?.CVO_TIN && (
                              <div>GSTIN/UIN: {listdata?.CVO_TIN || "NA"}</div>
                            )}
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3}>
                      Mode of { time_of} : {listdata?.make_of_payment || "NA"}
                    </td>
                    <td colSpan={3}>
                      Cheque Number : {listdata?.cheque_number || "NA"}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3}>
                      Instrument/TXN Details. :{" "}
                      {listdata?.intrument_details || "NA"}
                    </td>
                    <td colSpan={3}>
                      Transaction Mode : {listdata?.tr_mode || "NA"}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3}>AMOUNT : {listdata?.AMOUNT}</td>
                    <td colSpan={3}>Narration : {listdata?.NARRATION}</td>
                  </tr>
                  {doc_type == "PT" ? (
                    <tr>
                      {/* First Signature */}
                      <td
                        colSpan={2}
                        style={{
                          height: "100px",
                          textAlign: "center",
                          verticalAlign: "bottom",
                        }}
                      >
                        <div style={{ fontSize: "13px", marginTop: "5px" }}>
                          RECIEVER STAMP AND SIGNATURE
                        </div>
                      </td>

                      {/* Declaration */}
                      <td
                        colSpan={2}
                        style={{
                          height: "100px",
                          verticalAlign: "middle",
                          textAlign: "left",
                        }}
                      >
                        <div style={{ fontSize: "13px" }}>
                          <strong>TOTAL INVOICE AMOUNT (In Words):</strong>{" "}
                          {convertAmountToWords}
                        </div>
                        <div style={{ fontSize: "13px", marginTop: "5px" }}>
                          <strong>DECLARATION:</strong> This is system
                          generated. Hence no stamp and signature is required.
                        </div>
                      </td>

                      {/* Last Signature */}
                      <td
                        colSpan={2}
                        style={{
                          height: "100px",
                          textAlign: "center",
                          verticalAlign: "middle",
                        }}
                      >
                        {seal_image && signature_image && (
                          <div
                            style={{
                              position: "relative",
                              display: "inline-block",
                            }}
                          >
                            <img
                              src={seal_image}
                              alt="Seal"
                              style={{ height: "80px", width: "80px" }}
                            />
                            <img
                              src={signature_image}
                              alt="Signature"
                              style={{
                                position: "absolute",
                                height: "70px",
                                width: "70px",
                                top: "0%",
                                left: "35%",
                              }}
                            />
                          </div>
                        )}
                        <div style={{ fontSize: "13px", marginTop: "5px" }}>
                          STAMP AND SIGNATURE
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td
                        colSpan={6}
                        style={{ height: "100px", verticalAlign: "center" }}
                      >
                        <div
                          style={{
                            flex: 1,
                            height: "100%",
                            gap: ".25rem",
                            flexDirection: "row",
                            display: "flex",
                            alignItems: "flex-start",
                          }}
                        >
                          <div
                            style={{
                              flex: 1,
                              gap: ".25rem",
                              flexDirection: "column",
                              display: "flex",
                              justifyContent: "center",
                              height: "100%",
                            }}
                          >
                            <div style={{ fontSize: "13px" }}>
                              TOTAL INVOICE AMOUNT (In Words) :{" "}
                              {convertAmountToWords}
                            </div>

                            <div style={{ fontSize: "13px" }}>
                              DECLARATION : This is system generated.Hence no
                              stamp and signature is required.
                            </div>
                          </div>
                          <div
                            style={{
                              fontSize: "13px",
                              height: "100%",
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "flex-end",
                              margin: "0 1rem 1rem 0 ",
                              position: "relative",
                            }}
                          >
                            {seal_image && signature_image && (
                              <div
                                style={{
                                  position: "absolute",
                                  bottom: "11px",
                                  right: "30px",
                                }}
                              >
                                <img
                                  src={seal_image}
                                  alt=""
                                  style={{ height: "80px", width: "80px" }}
                                />
                                <img
                                  src={signature_image}
                                  alt=""
                                  style={{
                                    position: "absolute",
                                    height: "70px",
                                    width: "70px",
                                    top: "0%",
                                    left: "35%",
                                  }}
                                />
                              </div>
                            )}{" "}
                            STAMP AND SIGNATURE
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </table>
              </div>
            </div>
          ))}
      </div>
    );
  }
);

export default TaxInvoice4;
